import React, { useState, useRef, useEffect } from 'react';
import { useI18n } from '../../contexts/I18nContext';
import { Globe } from 'lucide-react';
import { LANGUAGES } from '../../constants';
import './LanguageSelector.scss';

const LanguageSelector = () => {
  const { language, setLanguage } = useI18n();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectLanguage = (langCode) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentLanguageName = LANGUAGES.find(l => l.code === language)?.name || 'English';

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button className="selector-toggle" onClick={toggleDropdown}>
        <Globe size={20} />
        <span>{currentLanguageName}</span>
      </button>
      {isOpen && (
        <ul className="selector-menu">
          {LANGUAGES.map((lang) => (
            <li 
              key={lang.code} 
              className={language === lang.code ? 'active' : ''}
              onClick={() => selectLanguage(lang.code)}
            >
              {lang.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;